// extracted by mini-css-extract-plugin
module.exports = {"row":"Legend_row__2Slt9","square":"Legend_square__14wYB","label":"Legend_label__3_Rxy","legendNoBins":"Legend_legendNoBins__3Up-G","squareNoBins":"Legend_squareNoBins__3bTe2"};